module.exports = __webpack_public_path__ + "img/cite2024.7caf9241.jpg";